import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../lib/api';
import AuthShell, {
  AuthHeader,
  AuthFooterLink,
  AuthSubmitButton,
  AuthError,
  AuthBackHome
} from '../components/auth/AuthShell';
import AuthField from '../components/auth/AuthField';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: searchParams.get('email') || '',
    code: '',
    password: '',
    confirm: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm) {
      setError('Passwords do not match');
      return;
    }
    if (form.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    setLoading(true);
    try {
      const data = await authAPI.resetPassword({
        email: form.email.trim().toLowerCase(),
        code: form.code.trim(),
        newPassword: form.password
      });
      if (data.success) {
        setDone(true);
        setTimeout(() => navigate('/login', { replace: true }), 2000);
      } else {
        setError(data.message || 'Could not reset password');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Could not reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell footer={<AuthBackHome />}>
      <AuthHeader
        title="Reset password"
        subtitle="Enter the code from your email and choose a new password."
      />

      {done ? (
        <p className="text-sm text-emerald-700">
          Password updated. Redirecting you to sign in…
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <AuthError message={error} />
          <AuthField
            id="email"
            label="Email"
            type="email"
            name="email"
            value={form.email}
            onChange={onChange}
            autoComplete="email"
            icon="envelope"
            required
          />
          <AuthField
            id="code"
            label="6-digit code"
            type="text"
            name="code"
            value={form.code}
            onChange={onChange}
            placeholder="123456"
            inputMode="numeric"
            maxLength={6}
            icon="lock"
            required
          />
          <AuthField
            id="password"
            label="New password"
            type="password"
            name="password"
            value={form.password}
            onChange={onChange}
            autoComplete="new-password"
            icon="lock"
            required
          />
          <AuthField
            id="confirm"
            label="Confirm password"
            type="password"
            name="confirm"
            value={form.confirm}
            onChange={onChange}
            autoComplete="new-password"
            icon="lock"
            required
          />
          <AuthSubmitButton loading={loading} loadingText="Saving…">
            Update password
          </AuthSubmitButton>
          <p className="text-center text-sm text-gray-500">
            No code?{' '}
            <Link to="/forgot-password" className="text-orange-600 font-medium hover:underline">
              Request a new one
            </Link>
          </p>
          <AuthFooterLink to="/login" prompt="Ready to sign in?" linkText="Login" />
        </form>
      )}
    </AuthShell>
  );
};

export default ResetPasswordPage;
